<template>
  <chart-card title="Média de itens na cesta" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaMediaItensMensal: [],
    listaMediaItensSemanal: [],
    listaMediaItensDiario: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        segmentos: this.stateFilters.segments,
      }
    },
    mediaItens() {
      if (this.filterType === 'mensal') return this.mediaItensMensal
      if (this.filterType === 'semanal') return this.mediaItensSemanal
      if (this.filterType === 'diario') return this.mediaItensDiario
      return ''
    },
    mediaItensMensal() {
      return helpers.agrupamentoMensal(this.listaMediaItensMensal, 'NUM_ITENS', 'NUM_CUPONS')
    },
    mediaItensSemanal() {
      return helpers.agrupamentoSemanal(this.listaMediaItensSemanal, 'NUM_ITENS', 'NUM_CUPONS')
    },
    mediaItensDiario() {
      return helpers.agrupamentoDiario(this.listaMediaItensDiario, 'VAL_ITENS_NA_CESTA')
    },
    chartData() {
      return {
        labels: [...this.mediaItens.map((object) => object.data)],
        datasets: [
          {
            label: 'Media itens',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.mediaItens.map((object) => object.valor.toFixed(2))],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaMediaItens: 'media-itens',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.empresaMediaItens({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.listaMediaItensMensal = data
          })
        } else if (this.filterType === 'semanal') {
          await this.empresaMediaItens({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.listaMediaItensSemanal = data
          })
        } else if (this.filterType === 'diario') {
          await this.empresaMediaItens({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.listaMediaItensDiario = data
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
